import { type Variation } from '@hooks-api/types/dataModel/products'
import style from './CartItem.module.scss'
import HighlightWord from './HighlightWord'
import { ArrowCircle, Freeze } from './Icon/icon'

type ClickableMode = 'WHOLE_DISPLAY_CLICABLE' | 'VARIATION_CLICKABLE_ONLY'

interface ClickableConfig {
  clickableMode: ClickableMode
  clickableHandler: () => void
}

interface ProductInfoDisplayProps {
  keyword: string
  isZoomInAllowed: boolean
  variation: Variation
  clickableConfig: ClickableConfig
}

const ProductInfoDisplay = ({
  keyword,
  isZoomInAllowed,
  variation,
  clickableConfig,
}: ProductInfoDisplayProps) => {
  const productInfoComponent = (
    <div className={style['product-info']}>
      <div className={style.img}>
        <img src={variation.thumbnail} alt={variation.name} />
        {variation.delivery_class === 'frozen' && <Freeze />}
      </div>

      <div className={style['title-variations']}>
        <h4 className={style.title}>
          <HighlightWord keyword={[...keyword]} words={variation.title} />
        </h4>
        <button
          className={style.variations}
          onClick={() => {
            clickableConfig.clickableHandler()
          }}
        >
          {variation.attributes && Object.values(variation.attributes).map((attr, index) => (
            <div key={index}>
              <HighlightWord keyword={[...keyword]} words={attr} />
            </div>
          ))}
          {isZoomInAllowed && <ArrowCircle className={style.arrow} />}
        </button>
      </div>
    </div>
  )
  const completeComponent
    = clickableConfig.clickableMode === 'WHOLE_DISPLAY_CLICABLE'
      ? (
        <a
          href="/#"
          className={style['whole-clickable-button']}
          onClick={(e) => {
            e.preventDefault()
          }}
        >
          <div>{productInfoComponent}</div>
        </a>
      )
      : (
        <div>{productInfoComponent}</div>
      )
  return <div>{completeComponent}</div>
}
export { ProductInfoDisplay, type ClickableMode }
